import React, { useEffect, useRef } from 'react';
import { updateProtocol } from '../../api/v1/protocols';
import { normalizeJson } from '../../util';
import './styles.scss';

type ApiResponse<T> = {
  data: T;
};

type CreateUserResponse = {
  message: string;
};

type ProtocolEditorProps = {
  initialValue: string;
  onSaveProtocol: (message: string) => void;
  protocolId: string;
};

const ProtocolEditor = ({ initialValue, onSaveProtocol, protocolId }: ProtocolEditorProps) => {
  const [editorValue, setEditorValue] = React.useState('');
  const editorRef = useRef<HTMLTextAreaElement>(null);

  const saveProtocol = async () => {
    const payload = {
      protocol: normalizeJson(editorValue)
    }

    const response = await updateProtocol(protocolId, payload) as ApiResponse<CreateUserResponse>;

    onSaveProtocol(response?.data.message);
  };

  useEffect(() => {
    setEditorValue(JSON.stringify(initialValue));
  }, [initialValue])

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.value = JSON.stringify(initialValue, null, 2);
    }
  }, [editorRef, initialValue])

  return (
    <div className="protocol-editor">
      <textarea ref={editorRef} onChange={(e) => setEditorValue(e.target.value)}/>

      <button className="save-button" onClick={() => saveProtocol()}>Save</button>
    </div>
  )
};


export default ProtocolEditor;
